import React, { useState } from "react";
import { Typography } from "antd";
import { CheckOutlined, PlusOutlined } from "@ant-design/icons";
import { features } from "../../data/data";
import "./Features.scss";

const { Title, Paragraph } = Typography;

const Features = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="feature-sections">
      <div className="feature-sections__container">
        <div className="feature-sections__header">About Our Services</div>
        <div className="feature-sections__title">
          Everything your team needs to bring your PDP to life
        </div>

        <div className="feature-sections__description">
          Our platform offers end-to-end services to help your team create,
          manage, share, and collaborate on all your PDP assets.
        </div>
      </div>

      {features.map((section, index) => (
        <div
          key={index}
          className={`feature-section 
          ${!isExpanded && index === 1 ? "feature-section--hidden" : ""} 
          ${!isExpanded && index >= 2 ? "feature-section__hidden" : ""} 
          ${
            index % 2 === 0 ? "feature-section--even" : "feature-section--odd"
          }`}
        >
          <div className="feature-section__content">
            <div className="feature-section__header">
              <div
                className={`feature-section__image-container ${
                  index % 2 === 0 ? "left" : "right"
                }`}
              >
                <img
                  src={section.image}
                  alt={section.title}
                  className="feature-section__image"
                />
              </div>

              <div className="feature-section__info">
                <Title level={2} className="feature-section__title">
                  {section.title}
                </Title>
                <Paragraph className="feature-section__description">
                  {section.description}
                </Paragraph>
              </div>
            </div>

            <div className="feature-section__list">
              {/* Desktop Table */}
              <table className="desktop-table">
                <tbody>
                  {section.featuresList.map((feature, index) => (
                    <tr key={index}>
                      <td className="feature-check-row">
                        <div
                          className={`feature-check ${
                            feature.isAdd ? "add-icon" : ""
                          }`}
                        >
                          {feature.isAdd ? <PlusOutlined /> : <CheckOutlined />}
                        </div>
                      </td>
                      <td className="title">{feature.title}</td>
                      <td className="description">{feature.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Mobile Table */}

              <table className="mobile-table">
                <tbody>
                  {section.featuresList.map((feature, index) => (
                    <tr key={index} className="mobile-feature">
                      <div className="mobile-feature-row">
                        <div
                          className={`feature-check ${
                            feature.isAdd ? "add-icon" : ""
                          }`}
                        >
                          {feature.isAdd ? <PlusOutlined /> : <CheckOutlined />}
                        </div>
                        <div className="title">{feature.title}</div>
                      </div>
                      <div className="mob-description">
                        {feature.description}
                      </div>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}

      {!isExpanded && (
        <div className="feature-section__gradient">
          <button onClick={() => setIsExpanded(true)} className="reveal-button">
            Reveal All Features
          </button>
        </div>
      )}

      <div className="get-started">
        {isExpanded && (
          <button
            className="reveal-button"
            onClick={() =>
              (window.location.href = "https://app.all3d.ai/register")
            }
          >
            Get Started for Free
          </button>
        )}
      </div>
    </div>
  );
};

export default Features;
